import React, { useEffect, useState } from "react";
import { v2_all_user } from "../../actions/v2/user";

const Form = ({ onSubmit, data }) => {
    const initialRow = {
        user: { name: "user", value: "", isRequired: true, error: "" },
        dateAttribute: { name: "dateAttribute", value: "", isRequired: true, error: "" },
        from: { name: "from", value: "", isRequired: true, error: "" },
        to: { name: "to", value: "", isRequired: true, error: "" },
        actualAttendance: { name: "actualAttendance", value: "", isRequired: false, error: "" },
        ot: { name: "ot", value: "", isRequired: false, error: "" },
        remark: { name: "remark", value: "", isRequired: false, error: "" },
    };

    const [state, setState] = useState([initialRow]);
    const [users, setUsers] = useState([]);
    const [applyToAll, setApplyToAll] = useState({
        dateAttribute: "",
        from: "",
        to: "",
        actualAttendance: "",
    });

    useEffect(() => {
        if (data && data.length > 0) {
            const prefill = data.map((item) => ({
                user: { name: "user", value: item.USER_ID || "", isRequired: true, error: "" },
                dateAttribute: { name: "dateAttribute", value: item.DATE_ATTRIBUTE || "", isRequired: true, error: "" },
                from: { name: "from", value: item.TIME_FROM || "", isRequired: true, error: "" },
                to: { name: "to", value: item.TIME_TO || "", isRequired: true, error: "" },
                actualAttendance: { name: "actualAttendance", value: item.ACTUAL_ATTENDANCE || "", isRequired: false, error: "" },
                ot: { name: "ot", value: item.OT || "", isRequired: false, error: "" },
                remark: { name: "remark", value: item.REMARK || "", isRequired: false, error: "" },
            }));

            setState(prefill);
        }
    }, [data]);

    useEffect(() => {
        v2_all_user().then((res) => {
            if (res.status) {
                setUsers(res.result);
            }
        });
    }, []);

    const handleChange = (rowIndex, field, value) => {
        const updatedState = [...state];
        updatedState[rowIndex][field].value = value;

        if (field === "from" || field === "to") {
            const from = updatedState[rowIndex].from.value;
            const to = updatedState[rowIndex].to.value;

            if (from && to) {
                const fromTime = new Date(`1970-01-01T${from}:00`);
                const toTime = new Date(`1970-01-01T${to}:00`);
                let diffMs = toTime - fromTime;
                if (diffMs < 0) diffMs += 24 * 60 * 60 * 1000;

                const decimalHours = diffMs / (1000 * 60 * 60);
                updatedState[rowIndex].actualAttendance.value = parseFloat(decimalHours.toFixed(2));
            } else {
                updatedState[rowIndex].actualAttendance.value = "";
            }
        }

        setState(updatedState);
    };

    const addRow = () => {
        setState([...state, { ...initialRow }]);
    };

    const deleteRow = (rowIndex) => {
        const updated = state.filter((_, idx) => idx !== rowIndex);
        setState(updated);
    };

    const handleApplyToAll = (field, value) => {
        setApplyToAll({ ...applyToAll, [field]: value });
        const updated = state.map((row) => ({
            ...row,
            [field]: { ...row[field], value },
        }));
        setState(updated);
    };

    const handleSave = () => {
        const formattedData = state.map((row) => ({
            user: row.user.value,
            dateAttribute: row.dateAttribute.value,
            from: row.from.value,
            to: row.to.value,
            actualAttendance: row.actualAttendance.value,
            ot: row.ot.value,
            remark: row.remark.value,
        }));

        onSubmit(formattedData);
    };

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="appraisal-report-table-responsive">
                    <table className="assessment-table" cellSpacing={0}>
                        <tbody>
                            <tr className="bghed">
                                <td>S.No.</td>
                                <td style={{ minWidth: '250px' }}>Name</td>
                                <td>Date Attribute</td>
                                <td>From</td>
                                <td>To</td>
                                <td>Actual Attendance</td>
                                <td>OT</td>
                                <td>Remark</td>
                                <td>Action</td>
                            </tr>

                            {/* Apply to All Row */}
                            <tr style={{ background: "#f5f5f5" }}>
                                <td colSpan={2}><b>Apply To All</b></td>
                                <td>
                                    <select
                                        className="form-control"
                                        value={applyToAll.dateAttribute}
                                        onChange={(e) => handleApplyToAll("dateAttribute", e.target.value)}
                                    >
                                        <option value="">Select</option>
                                        <option value="working_day">Working Day</option>
                                        <option value="leave">Leave</option>
                                        <option value="holiday">Holiday</option>
                                        <option value="weekend_off">Weekend Off</option>
                                    </select>
                                </td>
                                <td>
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={applyToAll.from}
                                        onChange={(e) => handleApplyToAll("from", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="time"
                                        className="form-control"
                                        value={applyToAll.to}
                                        onChange={(e) => handleApplyToAll("to", e.target.value)}
                                    />
                                </td>
                                <td>
                                    <input
                                        type="number"
                                        step='0.1'
                                        className="form-control"
                                        value={applyToAll.actualAttendance}
                                        onChange={(e) => handleApplyToAll("actualAttendance", e.target.value)}
                                    />
                                </td>
                                <td colSpan={3}></td>
                            </tr>

                            {state.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                    <td className="text-center">{rowIndex + 1}</td>

                                    {/* Name dropdown */}
                                    <td>
                                        <select
                                            className="form-control"
                                            value={row.user.value}
                                            onChange={(e) => handleChange(rowIndex, "user", e.target.value)}
                                        >
                                            <option value="">Select User</option>
                                            {users.map((u) => (
                                                <option key={u.USER_ID} value={u.USER_ID}>
                                                    {u.FULL_NAME}
                                                </option>
                                            ))}
                                        </select>
                                    </td>

                                    {/* Date Attribute */}
                                    <td>
                                        <select
                                            className="form-control"
                                            value={row.dateAttribute.value}
                                            onChange={(e) => handleChange(rowIndex, "dateAttribute", e.target.value)}
                                        >
                                            <option value="">Select</option>
                                            <option value="working_day">Working Day</option>
                                            <option value="leave">Leave</option>
                                            <option value="holiday">Holiday</option>
                                            <option value="weekend_off">Weekend Off</option>
                                        </select>
                                    </td>

                                    {/* From */}
                                    <td>
                                        <input
                                            type="time"
                                            className="form-control"
                                            value={row.from.value}
                                            onChange={(e) => handleChange(rowIndex, "from", e.target.value)}
                                        />
                                    </td>

                                    {/* To */}
                                    <td>
                                        <input
                                            type="time"
                                            className="form-control"
                                            value={row.to.value}
                                            onChange={(e) => handleChange(rowIndex, "to", e.target.value)}
                                        />
                                    </td>

                                    {/* Actual Attendance */}
                                    <td>
                                        <input
                                            type="number"
                                            step='0.1'
                                            className="form-control"
                                            value={row.actualAttendance.value}
                                            onChange={(e) =>
                                                handleChange(rowIndex, "actualAttendance", e.target.value)
                                            }
                                        />
                                    </td>

                                    {/* OT */}
                                    <td>
                                        <input
                                            type="number"
                                            className="form-control"
                                            value={row.ot.value}
                                            onChange={(e) => handleChange(rowIndex, "ot", e.target.value)}
                                        />
                                    </td>

                                    {/* Remark */}
                                    <td>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={row.remark.value}
                                            onChange={(e) => handleChange(rowIndex, "remark", e.target.value)}
                                        />
                                    </td>

                                    {/* Delete Button */}
                                    <td className="text-center">
                                        <button
                                            type="button"
                                            className="btn btn-sm btn-danger"
                                            onClick={() => deleteRow(rowIndex)}
                                        >
                                            X
                                        </button>
                                    </td>
                                </tr>
                            ))}

                            <tr className="addmoreitem">
                                <td colSpan={9}>
                                    <button type="button" className="btn btn-link" onClick={addRow}>
                                        + Add New User
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

                <button
                    className="btn btn-primary mt-3"
                    onClick={handleSave}
                    style={{
                        backgroundImage:
                            "linear-gradient(90deg, rgb(105, 150, 181), rgb(43, 90, 126))",
                        borderColor: "rgb(43, 90, 126)"
                    }}
                >
                    Submit
                </button>
            </div>
        </div>
    );
};

export default Form;
